import { ref, onMounted, onUnmounted } from 'vue';
export function useOrientation() {
    const orientation = ref(window.screen.orientation?.type || 'portrait-primary');
    const updateOrientation = () => {
        orientation.value = window.screen.orientation?.type || 'portrait-primary';
    };
    onMounted(() => {
        window.screen.orientation.addEventListener('change', updateOrientation);
    });
    onUnmounted(() => {
        window.screen.orientation.removeEventListener('change', updateOrientation);
    });
    return { orientation };
}
